module.exports = __webpack_public_path__ + "images/translate-1612bf12831aa799209ec8e642256fb7.svg";